import { c as _c } from "react/compiler-runtime";
import NextLink from 'next/link';
import { twMerge } from 'tailwind-merge';
type Props = {
  href: string;
} & React.ComponentPropsWithoutRef<typeof NextLink>;
export function MenuLink(t0) {
  const $ = _c(10);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = twMerge("menu-button", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== props || $[8] !== t1) {
    t2 = <NextLink hrefLang="en" className={t1} {...props}>{children}</NextLink>;
    $[6] = children;
    $[7] = props;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}